const CommissionActive = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z"
        fill="var(--adm-color-primary)"
      />
      <path
        d="M15.2727 13.5628H13.2273V9.93234C13.2273 9.2708 12.6709 8.7222 12 8.7222C11.3291 8.7222 10.7727 9.2708 10.7727 9.93234V13.5628H8.72727C8.05636 13.5628 7.5 14.1114 7.5 14.7729C7.5 15.4345 8.05636 15.9831 8.72727 15.9831H10.7727V16.7899C10.7727 17.4514 11.3291 18 12 18C12.6709 18 13.2273 17.4514 13.2273 16.7899V15.9831H15.2727C15.9436 15.9831 16.5 15.4345 16.5 14.7729C16.5 14.1114 15.9436 13.5628 15.2727 13.5628Z"
        fill="white"
      />
      <path
        d="M15.2727 10.3357C10.3389 10.3357 12.7147 10.3357 8.72727 10.3357C8.05636 10.3357 7.5 10.8843 7.5 11.5459C7.5 12.2074 8.05636 12.756 8.72727 12.756C12.0426 12.756 11.2235 12.756 15.2727 12.756C15.9436 12.756 16.5 12.2074 16.5 11.5459C16.5 10.8843 15.9436 10.3357 15.2727 10.3357Z"
        fill="white"
      />
      <path
        d="M12.7067 8.91795C9.21797 5.47791 12.9228 9.13104 10.1033 6.35084C9.62885 5.88305 8.84203 5.88305 8.36763 6.35084C7.89322 6.81862 7.89322 7.59446 8.36763 8.06225C10.7119 10.3738 8.10782 7.80607 10.9711 10.6294C11.4455 11.0971 12.2323 11.0971 12.7067 10.6294C13.1811 10.1616 13.1811 9.38574 12.7067 8.91795Z"
        fill="white"
      />
      <path
        d="M13.3763 10.6294C16.865 7.18933 13.1602 10.8425 15.9798 8.06226C16.4542 7.59448 16.4542 6.81864 15.9798 6.35085C15.5054 5.88307 14.7185 5.88307 14.2441 6.35085C11.8998 8.66244 14.5039 6.09467 11.6407 8.91796C11.1663 9.38575 11.1663 10.1616 11.6407 10.6294C12.1151 11.0972 12.9019 11.0972 13.3763 10.6294Z"
        fill="white"
      />
    </svg>
  );
};

export default CommissionActive;
